(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yuumae-hero-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yuumae-hero-video')) {
    customElements.define('yuumae-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.mobile = matchMedia('(max-width: 767px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pausedByUser = this.motion.matches || navigator.connection?.saveData === true;
        this.visible = true;
        this.button = this.querySelector('button');
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.pausedByUser = this.video ? !this.video.paused : false;
          if (!this.pausedByUser) this.load();
          this.update();
        }, options);
        this.mobile.addEventListener('change', () => {
          this.video?.pause(); this.video?.remove(); this.video = null;
          this.classList.remove('is-ready');
          if (!this.pausedByUser) this.load();
          this.update();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.pausedByUser = true; this.update(); }
        }, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible && !this.pausedByUser) this.load();
          this.update();
        });
        this.observer.observe(this);
      }
      load() {
        if (this.video) return;
        this.video = this.querySelector(this.mobile.matches ? '[data-video-mobile]' : '[data-video-desktop]').content.querySelector('video').cloneNode(true);
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.autoplay = true;
        this.video.preload = 'auto';
        this.video.setAttribute('aria-hidden', 'true');
        this.video.addEventListener('playing', () => { this.classList.add('is-ready', 'is-playing'); this.button.setAttribute('aria-label', this.dataset.pause); });
        this.video.addEventListener('pause', () => { this.classList.remove('is-playing'); this.button.setAttribute('aria-label', this.dataset.play); });
        this.video.addEventListener('error', () => { this.classList.remove('is-ready'); this.button.hidden = true; });
        this.insertBefore(this.video, this.button);
      }
      update() {
        if (!this.video) return;
        if (this.pausedByUser || !this.visible || document.hidden) this.video.pause();
        else {
          const video = this.video;
          video.play().catch(() => {
            if (this.video !== video || !video.paused) return;
            this.classList.remove('is-playing');
            this.button.setAttribute('aria-label', this.dataset.play);
          });
        }
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
